import { CircleArrowDown, CircleArrowUp, CircleCheck, CircleX, Mail, MoveDownLeft, MoveHorizontal, MoveUpRight, Phone, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import AddPerson from '../dialogs/AddPerson';
import { redirectToContact } from '../shared/customUiSdk';
import Dialogs from '../shared/Dialogs';
import Translate from '../shared/Translate';
import { formatDurationFromDates, formatDurationFromSeconds, formatPhoneNumber, formatTime, getBgColorClassName, getCallRemoteName, getCallRemoteNumber, getTextColorClassName } from '../shared/Utils';
import '../styles/main.css';

const Main = (props) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Function to update the current time
  const updateCurrentTime = () => {
    setCurrentTime(new Date().getTime());
  };

  // Set up an interval to update the current time every second
  useEffect(() => {
    const timer = setInterval(updateCurrentTime, 1000);

    // Clean up the interval when component unmounts
    return () => clearInterval(timer);
  }, []);

  const getIcon = (event) => {
    if (event.callType) {
      return <div className='notification-icon'>
        <Phone size={32} className='notification-icon-main' />
        {event.callType === 'inbound' && <MoveDownLeft size={16} className='notification-icon-top-right' />}
        {event.callType === 'outbound' && <MoveUpRight size={16} className='notification-icon-top-right' />}
        {event.callType === 'internal' && <MoveHorizontal size={16} className='notification-icon-top-right' />}
        {(event.state === 'disconnected' || event.state === 'error') && event.connectedNumber && <CircleCheck size={16} className='notification-icon-bottom-left green' />}
        {(event.state === 'disconnected' || event.state === 'error') && !event.connectedNumber && <CircleX size={16} className='notification-icon-bottom-left red' />}
      </div>
    }
    else {
      return <div className='notification-icon'>
        <Mail size={32} className='notification-icon-main' />
        {event.state === 'received' && <CircleArrowDown size={16} className='notification-icon-top-center' />}
        {event.state !== 'received' && <CircleArrowUp size={16} className='notification-icon-top-center' />}
      </div>
    }
  }

  const displayNotification = (notification, index) => {
    const isCall = notification?.event?.callType ? true : false;
    const remoteNumber = isCall
      ? getCallRemoteNumber(notification.event, props.callSettings?.lineSettings)
      : ((notification.event.state === 'received') ? notification.event.sender : notification.event.recipient);
    const remoteName = (isCall && getCallRemoteName(notification.event, props.callSettings?.lineSettings)) || '';
    const remoteNumberPerson = notification.pipedriveData?.persons?.find(person => person.phoneNumber === remoteNumber);
    const localNumberCall = isCall && (notification.event.callerNumber === remoteNumber ? notification.event.calledNumber : notification.event.callerNumber)
    const localNameCall = isCall && notification.pipedriveData?.persons?.find(person => person.phoneNumber === localNumberCall)?.personName

    return (
      <div
        key={index}
        className={`notification-item ${getBgColorClassName(notification)}`}
        onClick={() => {
          props.container.tell({
            _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$OpenFullScreenNotification',
            notificationId: notification._id,
          })
        }}
      >
        {getIcon(notification.event)}
        <div className='notification-item-body'>
          <div className='notification-item-body-row'>
            <div className="commlog-party-info compact">
              <div className="commlog-party-name compact">
                {remoteNumberPerson ? (
                  <span onClick={(e) => {
                    e.stopPropagation();
                    redirectToContact(props.sdk, remoteNumberPerson.personId)
                  }
                  }>
                    {remoteNumberPerson.personName}
                  </span>
                ) : (remoteName
                  ? <>
                    <div className='commlog-party-title'>{remoteName}</div>
                    <div className="source-label">{Translate.get('common.fromOptimCall.label')}</div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        Dialogs.open(
                          <AddPerson credentials={props.credentials} sdk={props.sdk} phoneNumber={remoteNumber} providedName={remoteName} />
                        )
                      }}
                      className="add-button"
                    >
                      {Translate.get('common.add.button')}
                    </button>
                  </>
                  : <>
                    <div className='commlog-party-title'>{Translate.get('common.unknown.label')}</div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        Dialogs.open(
                          <AddPerson credentials={props.credentials} sdk={props.sdk} phoneNumber={remoteNumber} />
                        )
                      }}
                      className="add-button"
                    >
                      {Translate.get('common.add.button')}
                    </button>
                  </>

                )}
              </div>
            </div>

            {isCall ?
              <div className='notification-details'>
                <div className='notification-detail'>{formatTime(notification.event.startTime, props.serverTimeOffset)} ({
                  (notification.pipedriveData?.callPhase === 'Disconnected' || notification.pipedriveData?.callPhase === 'Unknown')
                    ? formatDurationFromSeconds(notification.event.totalLength)
                    : formatDurationFromDates(notification.event.startTime, currentTime, props.serverTimeOffset)})
                </div>
              </div>
              :
              <div className='notification-details'>
                <div>
                  <div className='notification-detail'>{formatTime(notification.event.time, props.serverTimeOffset)}</div>
                </div>
              </div>
            }

            <div className="notification-details align-right">
              <div className={'state-text ' + getTextColorClassName(notification)}>
                {isCall
                  ? Translate.get('call.phase.' + (notification.pipedriveData?.callPhase || 'Unknown'))
                  : Translate.get('sms.state.' + notification.event.state)}
              </div>
            </div>

          </div>

          <div className='notification-item-body-row'>
            <div className="commlog-party-info compact">
              <div className="commlog-party-number">{formatPhoneNumber(remoteNumber)}</div>
            </div>

            {isCall ?
              <div className='notification-details'>
                <div>
                  {localNameCall && <div className='notification-detail'>{localNameCall}</div>}
                  {localNumberCall && <div className='notification-detail'>{formatPhoneNumber(localNumberCall)}</div>}
                </div>
              </div>
              :
              <div className='notification-details'>
                <div>
                  <div className='notificaion-detail truncate-multiline'>{notification.event.message}</div>
                </div>
              </div>
            }

            <div className="notification-details align-right">
              <div className="state-duration with-text-color-call-conversation">
                {(isCall && notification.pipedriveData?.conversationStartedAt && (
                  (() => {
                    if (notification.pipedriveData?.callPhase === 'Disconnected' || notification.pipedriveData?.callPhase === 'Unknown') {
                      return ''
                    }
                    else {
                      return formatDurationFromDates(notification.pipedriveData?.conversationStartedAt, currentTime, props.serverTimeOffset)
                    }
                  })()
                )) || <span style={{ visibility: 'hidden' }}>-</span>
                }
              </div>
            </div>
          </div>
        </div>
        <div
          className="notification-close"
          onClick={(e) => {
            e.stopPropagation();
            props.container.tell({
              _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$RemoveNotification',
              notificationId: notification._id,
            })
          }}
        >
          <X size={12} />
        </div>
      </div>
    );
  };

  return (
    <div className="main-container">
      {/* Notifications Section */}
      <div className="notifications-container">
        {props.mainScreenNotifications.length === 0 &&
          <div className="notifications-empty">
            <span>{Translate.get('main.notifications.empty')}</span>
          </div>
        }
        {props.mainScreenNotifications.map((notification, index) =>
          displayNotification(notification, index)
        )}
      </div>
    </div>
  );
};

export default Main